import { type FC } from 'react';
import { Dialog, IconButton, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface ImagePreviewDialogProps {
    imageUrl: string | null;
    onClose: () => void;
}

/**
 * Full-screen image preview dialog
 */
const ImagePreviewDialog: FC<ImagePreviewDialogProps> = ({ imageUrl, onClose }) => {
    return (
        <Dialog
            open={!!imageUrl}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    boxShadow: 'none'
                }
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)'
                    }
                }}
            >
                <CloseIcon />
            </IconButton>
            {imageUrl && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        p: 2
                    }}
                >
                    <img
                        src={imageUrl}
                        alt="Vista ampliada"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '90vh',
                            objectFit: 'contain'
                        }}
                    />
                </Box>
            )}
        </Dialog>
    );
};

export default ImagePreviewDialog;
